module.exports = __webpack_public_path__ + "static/fonts/DejaVuSerif.a4108b7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/DejaVu/DejaVuSerif.ttf?v=1.1
// module id = 1637
// module chunks = 28